// @flow
import React from 'react';
import type { Node } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MUISelect from '@material-ui/core/Select';
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import classnames from 'classnames';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontWeight: theme.typography.button.fontWeight
    },
    label: {
        marginRight: '1ch',
    },
    select: {
        display: 'flex',
        alignItems: 'center',
        height: 40,
        minWidth: 34,
        padding: '0px 14px',
    }

}));

type Props = $ReadOnly<{
    id: string,
    label: Node,
    value: string | number,
    options: $ReadOnlyArray<string | number>,
    onChange: (e: SyntheticEvent) => void,
    className?: string,
}>;
function Select({ id, label, value, options, onChange, className }: Props) {
    const classes = useStyles();

    return (
        <FormControl variant="outlined" className={classnames(classes.root, className)}>
            <label id={`${id}-label`}  className={classes.label}>
                {label}
            </label>
            <MUISelect
                id={id}
                value={value || ''}
                labelWidth={0}
                onChange={onChange}

                variant="outlined"
                classes={{
                    select: classes.select
                }}

            >
                {options && options.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </MUISelect>
        </FormControl>
    )
}

export default Select;